import type { FaireProductEntity } from "../../entity_types/product";

export const p_y73ghh659n: FaireProductEntity = {
  token: "p_y73ghh659n",
  type: "product",
  name: "Old But Awesome Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/5efc2e4bc62430a7311001987c06a2d15bd7e3386b3d7231ac7af0f2ff71cb50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8f840683bf39abd24db40f1eb6d4e1456c1c82f890429ce05087047cd61b8b6.jpeg"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:41.616Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
